export default function GoToJobIco({ size }) {
  return (
    <svg
      width={size || "9"}
      height={size || "9"}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09971 1.10001H2.19971C1.63965 1.10001 1.35942 1.10001 1.14551 1.209C0.957344 1.30487 0.804474 1.45774 0.708604 1.64591C0.599609 1.85982 0.599609 2.14005 0.599609 2.70011V6.50011C0.599609 7.06016 0.599609 7.34006 0.708604 7.55396C0.804474 7.74211 0.957344 7.89526 1.14551 7.99111C1.35921 8.10001 1.6391 8.10001 2.19806 8.10001H6.00116C6.56011 8.10001 6.83961 8.10001 7.05331 7.99111C7.24146 7.89526 7.39486 7.74196 7.49071 7.55381C7.59961 7.34011 7.59961 7.06051 7.59961 6.50156V5.60001M8.09961 3.10001V0.600006M8.09961 0.600006H5.59961M8.09961 0.600006L4.59961 4.10001"
        stroke="#7F56D9"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
